var _a;
import { WidgetResource } from '@pages/monitoring/types';
import extendWith from 'lodash-es/extendWith';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
// Order is important, the keys will be checked in case the view permission is denied while on the page
export var PERMISSION_MAP = (_a = {},
    _a[WidgetResource.Robot] = 'Robots.View',
    _a[WidgetResource.Queue] = 'Queues.View',
    _a[WidgetResource.Job] = 'Jobs.View',
    _a[WidgetResource.QueueSla] = 'Queues.View',
    _a);
export var resourceKeys = function () {
    return Object.keys(PERMISSION_MAP);
};
export var permissionMapFactory = function (appState) { return combineLatest(resourceKeys().map(function (resource) { return appState.user.permissions
    .isGranted(PERMISSION_MAP[resource])
    .pipe(map(function (isGranted) {
    var _a;
    return (_a = {},
        _a[resource] = isGranted,
        _a);
})); }).slice()).pipe(map(function (permissions) { return extendWith.apply(void 0, [{}].concat(permissions)); })); };
